import { Alert, Snackbar } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'

const AlertaSistema = (props) => {

    const {handleClose, open, mensaje} = props;

    /* const [open, setOpen] = useState(false); */

    return (
        <>
            <Stack spacing={2} sx={{ width: '100%' }}>
                <Snackbar 
                    open={open} 
                    autoHideDuration={4000} 
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        {mensaje}
                    </Alert>
                </Snackbar>
            </Stack>
        </>
    )
}

export default AlertaSistema